// import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
// import Loader from '../components/Loader'; 
import Footer from '../components/Footer';
import { footerEn } from '../data/footer';
import { navigationTop, navigationButtom } from '../params';
import { Link } from 'react-router-dom';

// import '../assets/scss/CoreLabsAboutUs.scss';
// import '../assets/scss/Articles.scss';
// import 'bootstrap/dist/css/bootstrap.min.css'; 




const navigationIntern = []

const crumb = [
    // { link: '//', text: 'Home' },
    { link: '//', text: 'Home' },

    { link: '/research/research-training', text: 'Research Training' },
    { link: '/research/citi', text: 'CITI' },
    { link: '/research/citi/amt', text: 'Advanced Mentorship Training (CITI)' },



]



function Rcr(props) {
    document.title = 'Advanced Mentorship Training (CITI)'
    const poster = '/uploads/core-labs.png'
    //const src = '/uploads/welcome.mp4'
    const headerData = {
        title: 'Advanced Mentorship Training (CITI)',
        crumb: crumb,
        navigationButtom: navigationButtom,
        navigationTop: navigationTop,
        applicationLinks: [{ text: 'Apply now', class: 'bordred', link: '/header/applynow' }],
    }



    return (
        <>
            <Navigation
                navigationIntern={navigationIntern}
                {...headerData}
                updateLang={props.updateLang}
            />
            <section className="space-block-60">
                <div className='container'>
                    <div className='row-listing'>
                        <p>The modules cannot be taken individually. All modules must be completed with an average score of at least 80% to receive the “Advanced Mentorship Training” Certificate.</p>

<div className="filter-container">
                            <table className="views-table full-width table-style-2" style={{ backgroundColor: '#ffffff' }}>

                                <thead>
                                    <tr>

                                        <th className="f-project-title">Course Title</th>
                                        <th className="f-project-lead">Relevance</th>
                                        <th className="f-project-entity">Suggested Integration at HBKU</th>
                                        <th className="f-project-entity">Duration (hrs) </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="even">

                                        <td>Creating a Mentoring Philosophy and Plan</td>
                                        <td>Describes the importance of having a mentoring philosophy and plan, the key elements of a mentoring philosophy and plan, strategies for developing a mentoring philosophy and plan, and considerations for being an effective mentor.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>

                                    </tr>
                                    <tr className="odd">

                                        <td>Determining Your Mentoring Model</td>
                                        <td>Discusses different ​mentoring models, the strengths and challenges ​of different mentoring models, and considerations for ongoing ​mentoring.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>
                                    </tr>
                                    <tr className="even">

                                        <td>Mentoring Across Levels</td>
                                        <td>Explains why different levels of mentees require different approaches to mentoring; how a mentor might approach mentoring with an undergraduate student, graduate student, postdoctoral fellow, and early career faculty; and considerations for ongoing mentoring.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>

                                    </tr>
                                    <tr className="odd">

                                        <td>Navigating the Phases of Mentoring</td>
                                        <td>Describes the four phases of mentoring, expectations for mentoring at each phase, and best practices within each of the four phases of mentoring.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>
                                    </tr>

                                    <tr className="even">

                                        <td>Setting and Aligning Expectations</td>
                                        <td>Covers the importance of setting and aligning expectations in mentoring, methods to amplify cultural ​awareness and sensitivity in mentoring, the process for setting expectations and key areas of alignment, and how to manage expectations.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>

                                    </tr>
                                    <tr className="odd">

                                        <td>Listening and Providing Effective Feedback</td>
                                        <td>Discusses the principles of effective communication, the traits and importance of active and attentive listening, how to engage in assertive communication, and methods and strategies for providing effective feedback.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>
                                    </tr>

                                    <tr className="even">

                                        <td>Supporting Career Development and Personal Growth</td>
                                        <td>Explains the importance of supporting ​career development and personal growth ​within the mentee-mentor relationship as well as strategies for promoting career development and personal growth, ​relationship building and networking, ​and mentee self-efficacy.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>

                                    </tr>
                                    <tr className="odd">

                                        <td>Maintaining Health, Safety, and Well-Being</td>
                                        <td>Describes the importance of health, safety, ​and well-being in mentoring; considerations for maintaining ​a physically and psychologically safe environment; strategies for supporting an ​optimal work-life balance; and tools and resources for mentee ​well-being.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>
                                    </tr>

                                     <tr className="even">

                                        <td>Developing Professional Knowledge and Technical Skills</td>
                                        <td>Discusses the role of the mentor in teaching professional knowledge and technical skills, ways to give mentees opportunities ​to demonstrate knowledge and skills, and methods to assess mentee ​knowledge and skills.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>

                                    </tr>
                                    <tr className="odd">

                                        <td>Cultivating Ethical Decision-Making</td>
                                        <td>Covers the importance of ethical ​decision-making in science, ways to model ethical decision-​making in mentoring, and other strategies to cultivate ​ethical decision-making in mentees.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>
                                    </tr>

                                     <tr className="even">

                                        <td>Assessing Your Effectiveness as a Mentor and Building an Organizational Culture for Mentoring</td>
                                        <td>Explains the importance of assessing ​your effectiveness as a mentor, ways to assess your effectiveness, strategies to improve ​your effectiveness, and ways to build (and maintain) an organizational culture for mentoring.</td>
                                        <td>Faculty and Principal Investigators</td>
                                        <td>30 Min</td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
      
            
                    </div>

                    {/* <div className="d-flex justify-content-center">
              <Loader />
          </div> */}
                </div>
            </section>
            <Footer {...footerEn} />
        </>
    )
}

export default Rcr;
